import { useState } from "react";

/**
 * 密码对话框相关状态 Hook
 */
const usePasswordDialogState = () => {
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  // 重置密码对话框状态
  const resetPasswordDialogState = () => {
    setPasswordDialogOpen(false);
    setPasswordForm({
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
  };

  return {
    passwordDialogOpen,
    setPasswordDialogOpen,
    passwordForm,
    setPasswordForm,
    resetPasswordDialogState,
  };
};

export default usePasswordDialogState;
